export enum PublishType{
    WsPublishWebApiStatus,
    WsPublishWebAppStatus,
    WsPublishWindowsServiceStatus,
    WsPublishNodeServiceStatus,
}